import { Injectable } from '@angular/core';

import { BuildABet } from 'packages/sports/web/app/src/tokens-base/token-base.models';

import { isBetBuilderPickId } from '../../../../../../core/utils';
import { BetAndGetToken, CriteriaType } from '../../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../../criteria-validator-base.service';

@Injectable()
export class BetAndGetBetBuilderValidator extends TokensCriteriaValidatorBase<BetAndGetToken, CriteriaType> {
    override type = CriteriaType.BetBuilder;

    constructor() {
        super();
    }

    isValid(token: BetAndGetToken, state: TokenValidationInput): boolean {
        if (token.buildABet) {
            const picks = state.selectedPicks;
            if (token.buildABet === BuildABet.Yes) {
                return picks.every((pick) => isBetBuilderPickId(pick.id));
            } else if (token.buildABet === BuildABet.No) {
                return !picks.some((pick) => isBetBuilderPickId(pick.id));
            }
        }

        return true;
    }
}
